// @oasis-permission-inherits: /jerboa (jerboa:view)
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dash/jerboa/rendering-results")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
